import useAuthStore from "@/store/auth";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
	loader() {
		const user = useAuthStore.getState().user;
		if (user && user.status === "ACTIVE") {
			if (user.userType.toLowerCase() === "buyer") {
				throw redirect({ to: "/buyer/home" });
			}
			else if (user.userType.toLowerCase() === "vendor") {
				throw redirect({ to: "/vendor/home" });
			}
		}
	},
	component: () => (
		<section className="flex h-screen w-full overflow-hidden">
			<div className="flex w-1/2 flex-col items-center justify-center space-y-20 bg-primary p-2 max-lg:hidden">
				<img className="h-10 w-44" src="/logo.png" alt="Intasida Logo" />
				<div className="w-96">
					<h1 className="text-wrap text-center text-4xl text-secondary">
						Receive
						<i className="mx-2 font-medium text-secondary/60">exactly</i>
						what you ordered
					</h1>
				</div>
				<img className="size-80" src="/wallet.png" alt="Wallet" />
			</div>
			<div className="w-1/2 overflow-auto px-20 py-6 max-lg:w-full max-sm:px-2">
				<Outlet />
			</div>
		</section>
	)
});
